import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EleicaoService } from '@/core/api/sicom-api/eleicoes/eleicao.service';
import { EleicaoPleito } from '@/core/api/sicom-api/eleicoes/eleicao-pleito.model';
import { EleicaoParticipacaoUf } from '@/core/api/sicom-api/eleicoes/eleicao-participacao-uf.model';
import { EleicaoTipoParticipacao, EleicaoVotante } from '@/core/api/sicom-api/eleicoes/eleicao-votante.model';
import { Page } from '@/shared/models/page.model';
import { CustomService } from '@/shared/services/custom.service';

@Injectable({ providedIn: 'root' })
export class EleicaoFeatureService extends CustomService {
    constructor(private core: EleicaoService) {
        super();
    }

    consultarPleitos(): Observable<EleicaoPleito[]> {
        return this.core.consultarPleitos().pipe(catchError(this.handleError));
    }

    consultarParticipacao(pleito: number, uf?: string): Observable<EleicaoParticipacaoUf[]> {
        return this.core.consultarParticipacao(pleito, uf).pipe(catchError(this.handleError));
    }

    consultarVotantes(pleito: number, uf: string | undefined, tipo: EleicaoTipoParticipacao, page?: number, size?: number): Observable<Page<EleicaoVotante>> {
        return this.core.consultarVotantes(pleito, uf, tipo, page, size).pipe(catchError(this.handleError));
    }
}
